module.exports = __webpack_public_path__ + "icons_084a6.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/icons.woff
// module id = 52
// module chunks = 0